import { render, staticRenderFns } from "./CloseBar.vue?vue&type=template&id=0438ed48&scoped=true&"
import script from "./CloseBar.vue?vue&type=script&lang=js&"
export * from "./CloseBar.vue?vue&type=script&lang=js&"
import style0 from "./CloseBar.vue?vue&type=style&index=0&id=0438ed48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0438ed48",
  null
  
)

export default component.exports